/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.clasificaciones': 'Clasificaciones',
'clasificaciones.agregarClasificaciones': 'Create Clasificaciones',
'clasificaciones.modificarClasificaciones': 'Edit Clasificaciones',
'clasificaciones.eliminarClasificaciones': 'Delete Clasificaciones',
'clasificaciones.clasificacionId': 'Clasificacion   Id ',
'clasificaciones.empresaId': ' Empresa   Id ',
'clasificaciones.clasificacionDescripcion': ' Clasificacion   Descripcion',
'clasificaciones.clasificaciones': 'Clasificaciones',
'clasificaciones.verClasificaciones': 'View Clasificaciones',
};

